<mat-progress-bar *ngIf="pending" mode="indeterminate"></mat-progress-bar>

<!--<h2 mat-dialog-title>Export {{selectedTitle}} Data to *.XLSX {{this.currentTable}} Table</h2>-->
<h2 mat-dialog-title>Export {{selectedTitle}} Data to *.XLSX Table</h2>
<mat-dialog-content class="mat-typography">

  <div class="export-grid">
    <div>
      <div class="export-grid__chips">
        <mat-chip-list
          *ngIf="chipsInit"
          class="mat-chip-list-stacked"
          cdkDropList
          cdkDropListOrientation="vertical"
          (cdkDropListDropped)="drop($event)"
          #chipList aria-label="Fruit selection">
          <mat-chip
            cdkDrag
            *ngFor="let row of rows"
            (removed)="remove(row)">
            {{row.name}}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
          <!-- Add Fields Button -->
          <button mat-stroked-button color="primary" [matMenuTriggerFor]="fieldsMenu">
            <mat-icon>add</mat-icon> Add fields
          </button>
          <mat-menu #fieldsMenu="matMenu">
            <button mat-menu-item *ngFor="let field of availableFields" (click)="addField(field)">
              {{field.name}}
            </button>
          </mat-menu>
        </mat-chip-list>
      </div>
    </div>
    <div class="export-grid__content">
<!--      <h3>Lorem ipsum dolor sit.</h3>-->
      <p>Please keep the fields you would like to export. Remove the fields you don't need. If you need to re-add the removed fields, please use 'Add fields'.</p>
      <mat-form-field appearance="fill">
        <mat-label>File Format</mat-label>
        <mat-select required (selectionChange)="onChange($event)" [value]="selectedFileFormat">
          <mat-option *ngFor="let format of fileFormat" [value]="format.value">
            {{format.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field *ngIf="['Production', 'Staging'].includes(this.currentTable)" appearance="fill">
        <mat-label>Presets</mat-label>
        <mat-select required (selectionChange)="onPresetChange($event)" [value]="selectedPreset">
          <mat-option *ngFor="let p of presetsList" [value]="p.value">
            {{p.viewValue}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <br>
      <button mat-stroked-button color="warn" (click)="resetSelectedFields()">Reset removed fields</button>

      <!-- Tag filter block -->
      <div style="margin-top:16px; border-top:1px solid #eee; padding-top:12px;">
        <h3>Tag filter</h3>
        <mat-radio-group [(ngModel)]="tagMode">
          <mat-radio-button value="all">Include all tags</mat-radio-button>
          <mat-radio-button value="include">Include only selected</mat-radio-button>
          <mat-radio-button value="exclude">Exclude all selected</mat-radio-button>
        </mat-radio-group>

        <div style="margin-top:8px; display:flex; gap:12px; align-items:center;">
          <mat-form-field appearance="fill" style="flex:1;">
            <mat-label>Search tags</mat-label>
            <input matInput [formControl]="tagSearch" placeholder="Type to filter tags" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
          <button mat-button (click)="toggleSelectAllTags()" [disabled]="!filteredTags.length">
            {{ selectAllTagsChecked ? 'Unselect All' : 'Select All' }}
          </button>
          <button mat-button color="accent" (click)="loadTags()" title="Reload tags">
            <mat-icon>refresh</mat-icon>
          </button>
          <!-- <button mat-button color="warn" (click)="checkAuth()" title="Check Auth">
            🔐 Auth
          </button> -->
        </div>

        <div style="max-height:220px; overflow:auto; border:1px solid #eee; border-radius:4px; padding:6px;">
          <!-- Message to start typing -->
          <div *ngIf="!filteredTags.length && (!tagSearch.value || tagSearch.value.length < 2) && allTags.length > 0" style="padding:12px; text-align:center; color:#666;">
            Type at least 2 characters to search {{ allTags.length | number }} available tags
          </div>

          <!-- No results when searching -->
          <div *ngIf="!filteredTags.length && tagSearch.value && tagSearch.value.length >= 2 && allTags.length" style="padding:12px; text-align:center; color:#666;">
            No tags found matching "{{ tagSearch.value }}"
          </div>

          <!-- Loading state -->
          <div *ngIf="!allTags.length" style="padding:12px; text-align:center; color:#666;">
            Loading tags...
          </div>

          <!-- No tags available -->
          <div *ngIf="allTags.length === 0 && filteredTags.length === 0 && !tagSearch.value" style="padding:12px; text-align:center; color:#666;">
            No tags available
          </div>
          <!-- Tag list -->
          <mat-selection-list [multiple]="true" *ngIf="filteredTags.length > 0" (selectionChange)="onTagSelectionChange($event)">
            <mat-list-option
              *ngFor="let tag of filteredTags"
              [selected]="isTagSelected(tag)"
              [value]="tag">
              {{ tag }}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </div>
      <!--      <mat-form-field class="select-row" appearance="fill">-->
<!--        <input-->
<!--          matInput-->
<!--          placeholder="Add row to export..."-->
<!--          #rowsInput-->
<!--          [formControl]="rowCtrl"-->
<!--          [matAutocomplete]="auto"-->
<!--          [matChipInputFor]="chipList"-->
<!--          [matChipInputSeparatorKeyCodes]="separatorKeysCodes">-->
<!--        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">-->
<!--          <mat-option *ngFor="let row of filteredRows | async" [value]="row">-->
<!--            {{row.name}}-->
<!--          </mat-option>-->
<!--        </mat-autocomplete>-->
<!--      </mat-form-field>-->
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-raised-button color="primary" [disabled]="rows.length === 0 || pending === true" cdkFocusInitial (click)="onExport()">Export</button>
</mat-dialog-actions>
